<mat-form-field class="light-form-field">
  <mat-label>{{
    label || ("certificates" | i18n) || "Qualifikationen" | titlecase
  }}</mat-label>
  <mat-select
    [ngModel]="_selectedCertificateIds"
    (ngModelChange)="onSelectionChange($event)"
    [disabled]="disabled"
    [required]="required"
    multiple
    [attr.data-cy]="'certificate-multiselect'">
    <mat-select-trigger>
      <ng-container *ngIf="_selectedCertificateIds.length === 0">
        {{ ("none" | i18n) || "Keine" }}
      </ng-container>
      <ng-container *ngIf="_selectedCertificateIds.length === 1">
        {{
          _selectedCertificateIds[0] === "ALL"
            ? ("all" | i18n) || "Alle"
            : _selectedCertificates[0]?.name || _selectedCertificateIds[0]
        }}
      </ng-container>
      <ng-container *ngIf="_selectedCertificateIds.length > 1">
        {{ _selectedCertificateIds.length }}
        {{ ("selected" | i18n) || "ausgewählt" }}
      </ng-container>
    </mat-select-trigger>

    <!-- ALL option as a regular selectable option -->
    <mat-option
      *ngIf="!hideAllOption"
      [value]="'ALL'"
      [attr.data-cy]="'certificate-option-all'">
      {{ ("all" | i18n) || "Alle" }}
    </mat-option>
    <mat-divider></mat-divider>

    <!-- Certificate groups options -->
    <ng-container *ngIf="certificateGroups.length">
      <mat-option
        *ngFor="let certificate of certificateGroups"
        [value]="certificate.id"
        [attr.data-cy]="'certificate-option-' + certificate.id">
        {{ certificate.displayName }}
      </mat-option>
      <mat-divider></mat-divider>
    </ng-container>

    <!-- Certificate options -->
    <mat-option
      *ngFor="let certificate of allCertificates"
      [value]="certificate._id"
      [attr.data-cy]="'certificate-option-' + certificate._id">
      {{ certificate.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
